<template>
  <v-menu
    v-model="showMenuPerformance"
    max-width="600px"
    min-width="600px"
    :position-x="showMenuPosition.x"
    :position-y="showMenuPosition.y"
    absolute
    offset-y
    :close-on-content-click="false"
  >
    <v-card class="pa-7">
      <v-row no-gutters>
        <v-col cols="12" class="py-0 performance-textarea">
          <h3 style="font-weight: 500">
            {{ $t('message.pages.video.copyPerformancePreLoading') }}
          </h3>
          <v-card-text class="px-0 py-0 mt-4">
            <v-row no-gutters>
              <v-col cols="12">
                <span
                  style="font-size: 1rem"
                  v-html="$t('message.pages.video.descPerformancePage')"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-textarea-legacy
            v-model="textMetadata"
            outlined
            class="wrapText mt-4"
            hide-details
            dense
            no-resize
            label="Metadata"
            color="primary"
            readonly
            style="font-size: 14px"
            @focus="$event.target.select()"
          >
            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    @click="handleShowLink(textMetadata)"
                    class="mr-2"
                  >
                    mdi-content-copy
                  </v-icon>
                </template>
                <span>
                  {{
                    isCopied
                      ? $t('message.pages.videoEditModal.copied')
                      : $t('message.pages.videoEditModal.copyToClipboard')
                  }}
                </span>
              </v-tooltip>
            </template>
          </v-textarea-legacy>
        </v-col>
      </v-row>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    video: {
      required: true,
    },
    isExternalSourceVideo: {
      type: Boolean,
      default: false,
      required: false,
    },
    showMenuPerformance: {
      default: false,
    },
    showMenuPosition: {
      default: () => ({
        x: 1500,
        y: 72,
      }),
    },
  },
  data: () => ({
    isCopied: false,
  }),
  watch: {
    showMenuPerformance(val) {
      this.$emit('showPerformance', val)
    },
  },
  computed: {
    textMetadata() {
      if (this.isExternalSourceVideo) {
        return `<link rel="preload" href="https://player.pandavideo.com.br/player.external.js" as="script">
<link rel="preload" href="https://config.tv.pandavideo.com.br/${this.video.pullzone_name}/${this.video.video_external_id}.json" as="fetch">
<link rel="preload" href="https://config.tv.pandavideo.com.br/${this.video.pullzone_name}/config.json" as="fetch">`
      }
      return `<link rel="preload" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/css/styles.css" as="style">
<link rel="prerender" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/?v=${this.video.video_external_id}">
<link rel="preload" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/js/hls.js" as="script">
<link rel="preload" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br/embed/js/plyr.polyfilled.min.js" as="script">
<link rel="preload" href="https://config.tv.pandavideo.com.br/${this.video.pullzone_name}/${this.video.video_external_id}.json" as="fetch">
<link rel="preload" href="https://config.tv.pandavideo.com.br/${this.video.pullzone_name}/config.json" as="fetch">
<link rel="preload" href="https://b-${this.video.pullzone_name}.tv.pandavideo.com.br/${this.video.video_external_id}/playlist.m3u8" as="fetch">
<link rel="dns-prefetch" href="https://b-${this.video.pullzone_name}.tv.pandavideo.com.br">
<link rel="dns-prefetch" href="https://player-${this.video.pullzone_name}.tv.pandavideo.com.br">
<link rel="dns-prefetch" href="https://${this.video.pullzone_name}.b-cdn.net">`
    },
  },
  methods: {
    handleShowLink(item) {
      this.isCopied = true
      navigator.clipboard.writeText(`${item}`)
      setTimeout(() => {
        this.isCopied = false
      }, 3000)
    },
  },
}
</script>
